export function clearScreen(screen) {
    screen.value = '';
    // calculate = 0;
}

